import { Box, Menu, Tooltip, MenuItem, IconButton } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import { Link } from "gatsby-plugin-react-i18next";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const paperProps = {
  elevation: 0,
  sx: {
    minWidth: 155,
    overflow: "visible",
    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
    mt: 1.5,
    "& .MuiAvatar-root": {
      width: 32,
      height: 32,
      ml: -0.5,
      mr: 1,
    },
    "&::before": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: "background.paper",
      transform: "translateY(-50%) rotate(45deg)",
      zIndex: 0,
    },
  },
};

export default function AccountMenu({ uid, user, firebase }) {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const logout = (event) => {
    event.preventDefault();

    if (firebase) {
      firebase.doSignOut();
      if (typeof window !== 'undefined') {
        window.location.reload();
      }
    }

  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Tooltip title="Account settings">
          <IconButton
            size="small"
            onClick={handleClick}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <PersonIcon fontSize="medium" sx={{ color: "primary.light" }} />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        anchorEl={anchorEl}
        slotProps={{ paper: paperProps }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
      >
        {user ? <MenuItem component={Link} to="/account">{user.name}</MenuItem> : <MenuItem component={Link} to="/login">{t("login")}</MenuItem>}
        {user ? <MenuItem component={Link} onClick={logout} to="/logout">{t("logout")}</MenuItem> : <MenuItem component={Link} to="/register">{t("register")}</MenuItem>}
        {user && <MenuItem component={Link} to="/account/companions">{t("my_companions")}</MenuItem>}
        {user && <MenuItem component={Link} to="/account/vehicles">{t("my_vehicles")}</MenuItem>}
        <MenuItem component={Link} to="/loginTickets">{t("my_trips")}</MenuItem>
      </Menu>
    </>
  );
}
